import React from 'react';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { HtmlTable } from '../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { COLUMN_HEADERS } from './components/StockOptionsTable/StockOptionsTable';
import { WorkflowComponentProps } from '../../Workflow/Workflow.meta';

interface Props {
  workflowProps?: WorkflowComponentProps;
}

export const StockOptionsEmpty = ({ workflowProps }: Props) => {
  return (
    <HtmlTable variant={workflowProps && 'bordered'}>
      <table>
        <caption>Stock Options / Restricted Stock</caption>

        <tbody>
          <tr>
            <td colSpan={COLUMN_HEADERS.length}>
              <Text fontWeight={500} color="neutral.500">
                You have not added any items.
              </Text>
            </td>
          </tr>
        </tbody>
      </table>
    </HtmlTable>
  );
};
